import React, { useEffect, useState } from "react";
import { Table, message } from "antd";
import { Helmet } from "react-helmet-async";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { fetchLogs } from "../../services/logService";
import { onShowSizeChange, itemRender } from "../../components/Pagination";
import LoadingSpinner from "../../components/Common/LoadingSpinner";
import { v4 as uuidv4 } from "uuid";

const LogsListPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const breadcrumbItems = [{ label: "Admin" }, { label: "System Logs" }];

  useEffect(() => {
    const loadLogs = async () => {
      try {
        const data = await fetchLogs();
        const rawLogs = data.logs || [];

        const parsedLogs = rawLogs.map((logStr) => {
          // Parse string: "[2025-07-25 22:24:08] INFO: User logged in"
          const timestampMatch = logStr.match(/\[(.*?)\]/);
          const levelMatch = logStr.match(/\] (\w+):/);
          const messageMatch = logStr.split(": ").slice(1).join(": ").trim();

          return {
            timestamp: timestampMatch ? timestampMatch[1] : "N/A",
            level: levelMatch ? levelMatch[1].toLowerCase() : "info",
            message: messageMatch,
            _key: uuidv4(),
          };
        });

        setLogs(parsedLogs);
      } catch (err) {
        console.error("Log parsing failed", err);
        message.error("Failed to load logs");
      } finally {
        setLoading(false);
      }
    };

    loadLogs();
  }, []);

  const columns = [
    {
    title: "Sr. No",
    key: "srno",
    render: (text, record, index) => index + 1,
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      render: (level) => {
        const text = level ? level.toUpperCase() : "UNKNOWN";
        const badgeClass = level === "error" ? "bg-danger" : level === "warn" ? "bg-warning" : "bg-primary";
        return <span className={`badge ${badgeClass}`}>{text}</span>;
      },
    },
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      sorter: (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
    },
  ];

  return (
    <div>
      <Helmet>
        <title>System Logs | CRM JNEC</title>
      </Helmet>
      <Header />
      <Sidebar activeClassName="list-logs" />
      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />
          {loading ? (
            <LoadingSpinner message="Loading logs..." />
          ) : (
            <div className="card card-table show-entire">
              <div className="card-body">
                <div className="table-responsive">
                  <Table
                    columns={columns}
                    dataSource={logs}
                    rowKey="_key"
                    pagination={{
                      total: logs.length,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      onShowSizeChange,
                      itemRender,
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LogsListPage;
